import { Check } from "lucide-react";
import { useTranslations } from "next-intl";

import type { ScoreOutcome } from "../lib/match-status";

const TONE: Record<ScoreOutcome, string> = {
  winner: "font-bold text-score-win",
  loser: "font-medium text-score-loss",
  // Тех. результат и отмена — не цвет сыгранной серии, а нейтраль + подпись.
  technicalWinner: "font-semibold text-foreground",
  technicalLoser: "font-medium text-muted-foreground",
  cancelled: "font-medium text-muted-foreground",
  neutral: "font-medium text-muted-foreground",
};

/**
 * Счёт стороны в ячейке сетки (KAN-650). Смысл передаётся не только цветом:
 * победителю — жирное начертание и галочка, тех. результату и отмене — видимая
 * подпись, и каждому исходу — текст для скринридера.
 */
export function ScoreValue({
  outcome,
  score,
  className = "",
}: {
  outcome: ScoreOutcome;
  score: number | string;
  className?: string;
}) {
  const t = useTranslations("Bracket.score");
  const tag =
    outcome === "technicalWinner" || outcome === "technicalLoser"
      ? t("technicalShort")
      : outcome === "cancelled"
        ? t("cancelledShort")
        : null;

  return (
    <span className={`inline-flex items-center gap-1 ${className} ${TONE[outcome]}`}>
      {outcome === "winner" ? <Check aria-hidden="true" className="h-3 w-3" /> : null}
      <span>{score}</span>
      {tag ? (
        <span aria-hidden="true" className="text-[10px] font-normal uppercase">
          {tag}
        </span>
      ) : null}
      {outcome !== "neutral" ? <span className="sr-only">{t(outcome)}</span> : null}
    </span>
  );
}
